export default __webpack_public_path__ + "static/media/screenshot1_sm.62f5a9b3.jpg";